// Clamp protects rendering against an invalid persisted or externally provided step.
export function clampStep(step: number, totalSteps: number) {
  if (totalSteps <= 0) {
    return 0;
  }

  return Math.max(0, Math.min(Math.floor(step), totalSteps - 1));
}
